<template>
    <app-content-admin>
        <template slot="header">{{$t("merchant_detail")}}</template>

        <v-layout row wrap>

            <v-flex xs12>
                <v-card class="pa-4">
                    <v-card-text class="text-center" v-if="$route.query.type === 'new'">
                        <v-icon large>mdi-check-circle-outline</v-icon>
                        <div class="text-h4 success--text font-weight-medium">Merchant created</div>
                        <p>Merchant main account will receive an email to setup password and activate the account.</p>

                        <v-divider></v-divider>
                    </v-card-text>

                    <v-card-title>
                        {{ $t('store_detail') }}
                    </v-card-title>

                    <v-card-text>
                        <v-form ref="form" v-model="valid">                            
                            <v-container fluid>
                                <v-layout wrap>

                                    <v-flex xs12 md6 lg4>
                                        <v-text-field
                                            :label="$t('brand')"
                                            v-model="form.brand"
                                            :rules="[rules.required('brand')]"
                                            counter="30"
                                            clearable
                                            outlined
                                        >
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12 md6 lg4>
                                        <v-text-field
                                            :label="$t('short_brand')"
                                            v-model="form.short_brand"
                                            :rules="[rules.required('short_brand')]"
                                            counter="11"
                                            clearable
                                            :hint="$t('character_only', {no: 11})"
                                            outlined
                                        >
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12 md6 lg4>
                                        <v-text-field
                                            v-model="form.point_brand"
                                            :label="$t('point_brand')"
                                            outlined
                                        >
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12 lg6>
                                        <v-textarea
                                            v-model="form.description"
                                            :label="$t('description')"
                                            outlined
                                        >
                                        </v-textarea>
                                    </v-flex>

                                    <v-flex xs12 lg6>
                                        <v-textarea
                                            v-model="form.address"
                                            :label="$t('address')"
                                            outlined
                                        >
                                        </v-textarea>
                                    </v-flex>

                                    <v-flex xs12 lg6>
                                        <v-autocomplete
                                            v-model="form.state"
                                            :label="$t('state')"
                                            :items="states"
                                            item-value="id"
                                            item-text="name"
                                            outlined
                                        >
                                        </v-autocomplete>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-textarea
                                            v-model="form.operating_hour"
                                            :label="$t('operating_hour')"
                                            item-value="value"
                                            item-text="name"
                                            outlined
                                        >
                                        </v-textarea>
                                    </v-flex>

                                    <v-flex xs12 md6>
                                        <v-text-field
                                            v-model="form.website_url"
                                            :label="$t('website_url')"
                                            type="url"
                                            outlined
                                        >
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12 md6>
                                        <v-text-field
                                            v-model="form.facebook_url"
                                            :label="$t('facebook_url')"
                                            type="url"
                                            outlined
                                        >
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12 md6>
                                        <label>{{ $t('store_image')}}</label>

                                        <v-hover v-slot="{ hover }" v-if="!changeImage">
                                            <v-card max-width="350" flat>
                                                <v-img class="align-center justify-center" 
                                                    height="250"
                                                    :src="form.image"
                                                    contain
                                                >
                                                    <v-expand-transition>
                                                        <div
                                                            v-if="hover"
                                                            class="d-flex transition-fast-in-fast-out v-card--reveal justify-center"
                                                            style="height: 100%;"
                                                        >
                                                            <v-btn small color="error" @click="changeImage = !changeImage">Delete</v-btn>
                                                        </div>
                                                    </v-expand-transition>
                                                </v-img>
                                            </v-card>
                                        </v-hover>
                                        

                                        <div v-else>
                                            <vue-dropzone
                                                ref="image"
                                                @vdropzone-success="uploadCallback"                                
                                                :options="dropzone_option"
                                                @vdropzone-removed-file="removedCallback">
                                            </vue-dropzone>
                                            <div class="text-right">
                                                <v-btn text color="error" @click="changeImage = false">Cancel</v-btn>
                                            </div>
                                        </div>
                                        
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="primary"
                                @click="submit()"
                            >
                                {{ $t('update') }}
                            </v-btn>
                        </v-card-actions>
                    </v-card-text>                   

                    <hr>

                    <v-card-title>
                        Customer Reward Points
                    </v-card-title>

                    <v-card-text>
                        <reward-setting></reward-setting>
                    </v-card-text>
                </v-card>

            </v-flex>

        </v-layout>

    </app-content-admin>

</template>

<script>
    import Dropzone from '@/mixins/Dropzone'
    import vForm from '@/mixins/vForm'
    import RewardSetting from '@/views/merchant/reward-setting'

    export default {
        mixins: [Dropzone, vForm],

        components: {
            RewardSetting,
        },

        data(){
            return{
                form:{
                    id: null,
                    brand: null,
                    short_brand: null,
                    point_brand: null,
                    description: null,
                    address: null,
                    state: null,
                    operating_hour:null,
                    website_url: null,
                    facebook_url: null,
                    image: null,
                    files: [],
                },
                dropzone_option: this.dropzoneOptions('image', api.path('merchant.upload')),
                states:[],
                changeImage: false,
            }
        },

        mounted(){
            this.getMerchant();
            this.getState();
        },

        methods: {
            async submit() {
                let loader = this.$loading.show();

                await axios.post(api.path('merchant.update'), this.form)
                .then(res => res.data)
                    .then(res =>  {
                        this.$toastr.s(this.$t(res.message));
                        this.getMerchant();
                        loader.hide();
                }).catch(error => {
                    console.log(error)
                        this.$toastr.e(error.response.data.message);
                        loader.hide();
                });

                loader.hide();
            },

            async getMerchant() {
                await axios.get(api.path('merchant.detail', {id: this.$route.params.id}))
                .then(res => res.data)
                    .then(res => {
                        this.form.id =  res.data.id;
                        this.form.brand =  res.data.brand;
                        this.form.short_brand =  res.data.short_brand;
                        this.form.description =  res.data.description;
                        this.form.facebook_url =  res.data.facebook_url;
                        this.form.website_url =  res.data.website_url;
                        this.form.operating_hour =  res.data.operating_hour;
                        this.form.point_brand =  res.data.point_brand;
                        this.form.address =  res.data.address;
                        this.form.state =  res.data.state;
                        this.form.image = res.data.image.path;
                        this.changeImage = false;
                    })
            },

            async getState() {
                await axios.get(api.path('lookup.state')).then(res => res.data).then(res => {
                    return this.states = res.data;
                })
            }

        }
    }

</script>
